import styled from 'styled-components'
import colors from '../../../configuration/colors'

export default styled.button.attrs(props => ({
  className: `${props.className ?? ''} quest-btn btn-a ${props.disabled ? 'disabled' : ''}`
}))`
  width: ${props => props.fixedWidth ? '104px' : 'max-content'};
  height: ${props => props.height ?? '40px'};
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  line-height: 1;

  &:disabled {
    background: ${props => props.theme.rockLine};
    color: ${props => props.theme.caption2color};
  }

  &.blue {
    background: linear-gradient(135deg, ${colors.cyan} 0%, #53A9FF 100%);
    color: ${colors.white};

    &:hover {
      background: linear-gradient(135deg, hsl(209, 100%, 54%) 0%, hsl(210, 100%, 70%) 100%);
      color: ${colors.white};
    }
  }
`
